<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>材料管理</el-breadcrumb-item>
      <el-breadcrumb-item>零件</el-breadcrumb-item>
    </el-breadcrumb>
    <order-list :category="1"></order-list>
  </div>
</template>

<script>
import OrderList from './index'
export default {
  components: { OrderList },
}
</script>